<template>
    <div style="padding-top: 65px;overflow: scroll;" :class="{'hidden':isPC}">
        <el-row>
<!--            返回栏-->
            <el-col :span="24" style="height: 60px;background-color:#EAEAEA;width: 100vw;box-shadow: inset 0px 10px 10px #DDDDDD;z-index: 2">
                <div style="">
                    <i class="el-icon-d-arrow-left" style="font-size: 20px;line-height: 58px; text-align: left;padding-left:40px;" @click="this.$router.go(-1)">
                        <i style="font-size: 18px;font-style: normal;font-weight: bold;"> {{base[0]}}</i>
                    </i>

                </div>

            </el-col>
<!--            主体-->
            <el-col :xs="1" :sm="1" :md="3" :lg="3" :xl="3"></el-col>
            <el-col :xs="22" :sm="22" :md="18" :lg="18" :xl="18"  style="margin-top: 60px;">
                <el-row :class="{'lunbotu':isPC}">
<!--                    轮播图-->
                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="border" >
                        <div class="carouseldiv" style="overflow: hidden">
                        <el-carousel ref="carousel"  style="width: 100%;height: 50vh;border-bottom: 1px solid #ccc;overflow: hidden; margin-top: 0 !important;padding-top: 0" :autoplay="false" v-if='lists.length > 0'>
                            <el-carousel-item v-for="(item,index) in lists" :key="item" :initial-index="0" style="height: 50vh;text-align: center;display: flex;" >
                                <img :src="item" :title="name"  alt="图例" style="height: 100%;width: 100%">


                            </el-carousel-item>
                        </el-carousel>
                            <ul>
                                <li  style="height: 100px;width: 100px;float: left;margin: 10px 10px 0 0;border: 1px solid #ccc;cursor: pointer "
                                     v-for="(item,index) in lists" @click="this.$refs.carousel.setActiveItem(index)">
                                    <img :src="item" :title="name"  alt="图例" style="height: 100%;width: 100%">
                                </li>
                            </ul>

                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="briefIntroduction" >
                        <h1>{{name}}</h1>
                        <div  class="jianjie">
                            SN： {{sn}}
                        </div>
                        <div >
                            <div :xs="24" :sm="24" :md="8" :lg="8" :xl="8" style="padding: 10px 0;display: inline-block;width: 33%;text-align: center" v-show="canDraw" >
                                <img src="../../../assets/zt40c6fd7f.jpg" style="width: 100%;height: 80%;padding-bottom: 25px"/>
                                <el-button @click="draw()" type="primary">AI智能绘图</el-button>
<!--                                <p style="color: #db261d;font-style: normal">提示：根据尺寸通过精密的计算并绘制出精准的图纸</p>-->
                            </div>
                             <div :xs="24" :sm="24" :md="8" :lg="8" :xl="8" style="padding-top:10px;display: inline-block;width: 33%;text-align: center">
                                 <img src="../../../assets/2165aczHJCbbzJh.jpg" style="width: 100%;height: 80%;border-radius: 5px;padding-bottom: 35px"/>
                                <el-button @click="power()"  type="primary">智能功率计算</el-button>
                             </div>
                            <div :xs="24" :sm="24" :md="8" :lg="8" :xl="8" style="padding-top:10px;display: inline-block;width: 33%;text-align: center" v-show="canDraw" >
                                <img src="../../../assets/f7b09c60ac531ceff1bee5970a57f62.png" style="width: 100%;height: 80%;padding-bottom: 10px"/>
                                <el-button @click="emulational()"  type="primary">变压器仿真</el-button>
                            </div>
                        </div>
                    </el-col>
            </el-row>
            </el-col>
        <!--计算功率-->
            <el-col v-show="a" :xs="1" :sm="1" :md="3" :lg="3" :xl="3"></el-col>
            <el-col v-show="a" :xs="1" :sm="1" :md="3" :lg="3" :xl="3"></el-col>
            <el-col v-show="a" :xs="22" :sm="22" :md="18" :lg="18" :xl="18" style="margin: 30px 0;border-top: 1px solid #ccc">

                <div>
                    <el-form ref="form" class="form" :model="form">
                    <el-row>
                        <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" v-show="a">
                            <el-form-item label="A" prop="a">
                                <el-input  type="number" v-model="form.a"  />
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="B" prop="b">
                                <el-input type="number" v-model="form.b"  />
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="C" prop="c">
                                <el-input   type="number" v-model="form.c"   />
                            </el-form-item>
                        </el-col>
<!--                        以上环形abc-->

                        <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="D" prop="d">
                                <el-input  type="number" v-model="form.d"  />
                            </el-form-item>
                        </el-col>
                        <el-col v-show="e" :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="E" prop="e">
                                <el-input  type="number" v-model="form.e"  />
                            </el-form-item>
                        </el-col>
                        <el-col v-show="f" :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="F" prop="f">
                                <el-input  type="number" v-model="form.f"  />
                            </el-form-item>
                        </el-col>
<!--以上UF、EE、UYF、EC、ET、FT  abcdef-->
                        <el-col v-show="g" :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="G" prop="g">
                                <el-input  type="number" v-model="form.g" model-value="0" />
                            </el-form-item>
                        </el-col>
<!--                        以上EI、EED、UI、EP ebcdefg-->

                        <el-col v-show="b1" :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="B1" prop="b1">
                                <el-input  type="number" v-model="form.b1"  model-value="0" />
                            </el-form-item>
                        </el-col>
                        <el-col v-show="d1" :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="D1" prop="d1">
                                <el-input  type="number" v-model="form.d1" model-value="0" />
                            </el-form-item>
                        </el-col>

                        <el-col v-show="h" :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="H" prop="h">
                                <el-input  type="number" v-model="form.h" model-value="0" />
                            </el-form-item>
                        </el-col>
<!--以上efd、epc efd没有g 并且efd分为三种 epc分为两种-->
<!--                        pq abcdefgh-->
<!--                        rm abcdefghh1i rm分为两种-->
<!--                        PM abcdefghi-->
                        <el-col v-show="h1" :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="H1" prop="jh1">
                                <el-input  type="number" v-model="form.h1" model-value="0" />
                            </el-form-item>
                        </el-col>
                        <el-col v-show="i" :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="I" prop="i">
                                <el-input  type="number" v-model="form.i" model-value="0" />
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-form-item label="Frequency频率f(KHz)" prop="khz">
                                <el-input  type="number" v-model="form.khz" model-value="0" />
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-form-item label="电流密度j(A/mm2)" prop="ja">
                                <el-input  type="number" v-model="form.ja" model-value="0" placeholder="最大4"/>
                            </el-form-item>
                        </el-col>
                        <el-col ::xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-form-item label="窗口填充系数(KW)" prop="km">
                                <el-input  type="number" v-model="form.km" model-value="0" placeholder="常用0.4"/>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-form-item label="磁通密度T(1T=1000mT)" prop="t">
                                <el-input  type="number" v-model="form.t" model-value="0" />
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-button @click="TPW">计算输出功率</el-button>



                        </el-col>
                    </el-row>
                    </el-form>
                    <div style="width: 100%;margin-top: 6px" v-if="isgonglv">
                        <el-table
                                :data="gonglv"
                                style="width: 100%">
                            <el-table-column
                                    prop="name"
                                    label="品名"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="sn"
                                    label="SN"
                            >
                            </el-table-column>
                            <el-table-column label="输出功率" >
                                <el-table-column
                                        prop="AW"
                                        label="AW"
                                >
                                </el-table-column>
                                <el-table-column
                                        prop="TPW"
                                        label="正激拓扑电路Po(W)"
                                >
                                </el-table-column>
                                <el-table-column
                                        prop="QQW"
                                        label="全桥推挽电路Po(W)"
                                >
                                </el-table-column>
                            </el-table-column>

                        </el-table>


                    </div>
                </div>

            </el-col>

<!--        計算出來的其他參數-->
            <el-col :xs="1" :sm="1" :md="3" :lg="3" :xl="3"></el-col>
            <el-col :xs="1" :sm="1" :md="3" :lg="3" :xl="3"></el-col>
            <el-col :xs="22" :sm="22" :md="18" :lg="18" :xl="18"  style="margin: 30px 0;border-top: 1px solid #ccc">

                <div style="overflow: hidden">
                    <ul class="menuBtn">
                        <li v-for="(item,index) in btns" >
                            <el-button :class="{colorChange:index==dynamic}" @click="getindex(index)">{{item}}</el-button>
                        </li>
                    </ul>
                </div>
                <el-select v-model="value" @change="xuanzhong" placeholder="请选择材料(默认H40)">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"

                    >
                    </el-option>
                </el-select>
                <div class="data" v-if="0==dynamic">
                    <div style="width: 100%;margin-top: 6px">
                        <el-table
                                :data="tableData"
                                style="width: 100%">
                            <el-table-column
                                    prop="name"
                                    label="品名"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="sn"
                                    label="SN"
                            >
                            </el-table-column>
                            <el-table-column label="尺寸(mm)" >
                                <el-table-column
                                        prop="A"
                                        label="A"
                                >
                                    
                                    <span v-if='tableData[0].A.indexOf("-")==-1||
                                    tableData[0].A.indexOf("+")==-1
'                                   >
                                        {{tableData[0].A}}
                                    </span>
                                    <!-- 判断尺寸中是否有正负公差-->
                                    <span v-else >
                                        {{tableData[0].A.split("-")[0]}}
                                        <sup style="position: absolute;top: 2px">
                                            -{{tableData[0].A.split("-")[1].split("+")[0]}}
                                        </sup>
                                        <sub style="position: absolute;top: 17px">
                                            +{{tableData[0].A.split("-")[1].split("+")[1]}}
                                        </sub>
                                    </span>
                                    
                                    
                                </el-table-column>
                                <el-table-column
                                        prop="B"
                                        label="B"
                                >
                                     <span v-if='tableData[0].B.indexOf("-")==-1||
                                    tableData[0].B.indexOf("+")==-1
'                                   >
                                        {{tableData[0].B}}
                                    </span>
                                    <!-- 判断尺寸中是否有正负公差-->
                                    <span v-else >
                                        {{tableData[0].B.split("-")[0]}}
                                        <sup style="position: absolute;top: 2px">
                                            -{{tableData[0].B.split("-")[1].split("+")[0]}}
                                        </sup>
                                        <sub style="position: absolute;top: 17px">
                                            +{{tableData[0].B.split("-")[1].split("+")[1]}}
                                        </sub>
                                    </span>
                                </el-table-column>
                                <el-table-column
                                        prop="C"
                                        label="C"
                                >
                                     <span v-if='tableData[0].C.indexOf("-")==-1||
                                    tableData[0].C.indexOf("+")==-1
'                                   >
                                        {{tableData[0].C}}
                                    </span>
                                    <!-- 判断尺寸中是否有正负公差-->
                                    <span v-else >
                                        {{tableData[0].C.split("-")[0]}}
                                        <sup style="position: absolute;top: 2px">
                                            -{{tableData[0].C.split("-")[1].split("+")[0]}}
                                        </sup>
                                        <sub style="position: absolute;top: 17px">
                                            +{{tableData[0].C.split("-")[1].split("+")[1]}}
                                        </sub>
                                    </span>
                                </el-table-column>
                                <el-table-column
                                        prop="D"
                                        label="D"
                                >
                                     <span v-if='tableData[0].D.indexOf("-")==-1||
                                    tableData[0].D.indexOf("+")==-1
'                                   >
                                        {{tableData[0].D}}
                                    </span>
                                    <!-- 判断尺寸中是否有正负公差-->
                                    <span v-else >
                                        {{tableData[0].D.split("-")[0]}}
                                        <sup style="position: absolute;top: 2px">
                                            -{{tableData[0].D.split("-")[1].split("+")[0]}}
                                        </sup>
                                        <sub style="position: absolute;top: 17px">
                                            +{{tableData[0].D.split("-")[1].split("+")[1]}}
                                        </sub>
                                    </span>
                                </el-table-column>
                                <el-table-column
                                        prop="E"
                                        label="E"
                                >
                                     <span v-if='tableData[0].E.indexOf("-")==-1||
                                    tableData[0].E.indexOf("+")==-1
'                                   >
                                        {{tableData[0].E}}
                                    </span>
                                    <!-- 判断尺寸中是否有正负公差-->
                                    <span v-else >
                                        {{tableData[0].E.split("-")[0]}}
                                        <sup style="position: absolute;top: 2px">
                                            -{{tableData[0].E.split("-")[1].split("+")[0]}}
                                        </sup>
                                        <sub style="position: absolute;top: 17px">
                                            +{{tableData[0].E.split("-")[1].split("+")[1]}}
                                        </sub>
                                    </span>
                                </el-table-column>
                                <el-table-column
                                        prop="F"
                                        label="F"


                                >
                                     <span v-if='tableData[0].F.indexOf("-")==-1||
                                    tableData[0].F.indexOf("+")==-1
'                                   >
                                        {{tableData[0].F}}
                                    </span>
                                    <!-- 判断尺寸中是否有正负公差-->
                                    <span v-else >
                                        {{tableData[0].F.split("-")[0]}}
                                        <sup style="position: absolute;top: 2px">
                                            -{{tableData[0].F.split("-")[1].split("+")[0]}}
                                        </sup>
                                        <sub style="position: absolute;top: 17px">
                                            +{{tableData[0].F.split("-")[1].split("+")[1]}}
                                        </sub>
                                    </span>
                                </el-table-column>
                                <el-table-column
                                        prop="D1"
                                        label="D1"
                                        v-if="d1"
                                        :formatter="NameFormat4"

                                >
                                </el-table-column>
                                <el-table-column
                                        prop="D1"
                                        label="D1"
                                        v-if="d1"
                                        :formatter="NameFormat4"

                                >
                                </el-table-column>
                                <el-table-column
                                        prop="G"
                                        label="G"
                                        v-if="gcheck"
                                        :formatter="NameFormat1"
                                >
                                </el-table-column>
                                <el-table-column
                                        prop="H"
                                        label="H"
                                        v-if="hcheck"
                                        :formatter="NameFormat2"

                                >
                                </el-table-column>

                                <el-table-column
                                        prop="I"
                                        label="I"
                                        v-if="icheck"
                                        :formatter="NameFormat3"
                                >
                                </el-table-column>



                            </el-table-column>

                        </el-table>


                    </div>
                    <div style="width: 100%;margin-top: 6px">
                        <el-table
                                :data="tableData"
                                style="width: 100%">
                            <el-table-column
                                    prop="name"
                                    label="品名"
                            >
                            </el-table-column>

                            <el-table-column label="磁芯参数">

                                <el-table-column
                                        prop="C1"
                                        label="C1"
                                >
                                </el-table-column>
                                   <el-table-column
                                           prop="C2"
                                           label="C2"
                                   >
                                   </el-table-column>
                                <el-table-column
                                        prop="Ae"
                                        label="Ae(mm^2)"
                                >
                                </el-table-column>
                                <el-table-column
                                        prop="Le"
                                        label="Le(mm)"
                                >
                                </el-table-column>
                                <el-table-column
                                        prop="Ve"
                                        label="Ve(mm^3)"
                                >
                                </el-table-column>
                                <el-table-column
                                        prop="wt(g)"
                                        label="wt(g)"
                                >
                                </el-table-column>

                            </el-table-column>
                            <el-table-column
                                    prop="Al"
                                    label="AL(Nh/N2)"
                            >
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div v-else>
                    <h3>{{base[2]}}</h3>
                    <p v-html="describe"></p>
                </div>

            </el-col>

        </el-row>
        <foot/>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import Foot from "@/ZH-CN/components/Foot";
    import { getCurrentInstance } from "vue";
    export default {
        name: "EE",
        components: {Foot},
        metaInfo: {
            title: '产品中心 | 南京恒创磁电有限公司 - Powered by MeCMS', // set a title
            meta: [{
                // 设置meta信息
                name: '大功率铁氧体磁芯|大功率磁芯|软磁铁氧体磁芯|锰锌铁氧体磁芯|大尺寸磁芯|X光磁芯|高压变压器磁芯|微波铁氧体',
                content: '大功率磁芯,南京恒创磁电专业生产各种高品质大磁芯，大功率铁氧体磁芯，软磁铁氧体磁芯，锰锌铁氧体磁芯，大尺寸磁芯，X光磁芯，高压变压器磁芯，电话:18913981759'
            }]
        },
        data(){

            return{
                isPC:true,
                base:['返回上一级',"软件制图",'产品介绍'],
                btns:['产品尺寸','相关介绍'],
                sn:'',
                list:[],
                lists:[],
                describe:'',
                dynamic:0,
                show:true,
                tableData: [],
                gonglv: [],
                name:"",
                gcheck:true,
                hcheck:true,
                icheck:true,
                canDraw:false,
                canGongLv:false,
                options: [],
                value:"",
                proxys:"",
                form:{t:0,km:0,ja:0,khz:0},
                a:false,b:false,c:false,d:false,e:false,f:false,g:false,b1:false,d1:false,
                h:false,h1:false,i:false,
                isgonglv:false

            }
        },
        methods:{
            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },
            getindex(index) {

                //点击添加字体颜色，其他的删除class名称
                this.dynamic = index;
             },
            draw(){


                if (this.name.startsWith("EE")&&!this.name.startsWith("EEL")&&!this.name.startsWith("EED")){
                    this.$router.push({path:'/Calc/page/EE',query:{sn:this.sn}})

                }else if(this.name.startsWith("UF")&&!this.name.startsWith("UFR")){
                    this.$router.push({path:'/Calc/page/UF',query:{sn:this.sn}})
                }else if(this.name.startsWith("EC")&&!this.name.startsWith("ECO")) {
                    this.$router.push({path: '/Calc/page/EC', query: {sn: this.sn}})
                }else if(this.name.startsWith("H")){
                    this.$router.push({path:'/Calc/page/H',query:{sn:this.sn}})
                }else if(this.name.startsWith("PQ")){
                    this.$router.push({path:'/Calc/page/PQ',query:{sn:this.sn}})
                }else if(this.name.startsWith("EQ")){
                    this.$router.push({path:'/Calc/page/EQ',query:{sn:this.sn}})
                }else if(this.name.startsWith("UY")&&!this.name.startsWith("UYF")){
                    this.$router.push({path:'/Calc/page/UY',query:{sn:this.sn}})
                }else{
                    this.$message({
                        type: "error",
                        message: "无法绘制图纸"
                    })
                }

            },
            //仿真
            emulational(){

                if (this.name.startsWith("EE")&&!this.name.startsWith("EEL")&&!this.name.startsWith("EED")){
                    this.$router.push({path:'/Transformer/page/EE',query:{sn:this.sn}})

                }else if(this.name.startsWith("UF")&&!this.name.startsWith("UFR")){
                    this.$router.push({path:'/Transformer/page/UF',query:{sn:this.sn}})
                }else if(this.name.startsWith("EC")&&!this.name.startsWith("ECO")) {
                    this.$router.push({path: '/Transformer/page/EC', query: {sn: this.sn}})
                }else if(this.name.startsWith("H")){
                    this.$router.push({path:'/Transformer/page/H',query:{sn:this.sn}})
                }else if(this.name.startsWith("PQ")){
                    this.$router.push({path:'/Transformer/page/PQ',query:{sn:this.sn}})
                }else if(this.name.startsWith("EQ")){
                    this.$router.push({path:'/Transformer/page/EQ',query:{sn:this.sn}})
                }else if(this.name.startsWith("UY")&&!this.name.startsWith("UYF")){
                    this.$router.push({path:'/Transformer/page/UY',query:{sn:this.sn}})
                }else{
                    this.$message({
                        type: "error",
                        message: "无法绘制图纸"
                    })
                }
            },
            xuanzhong(){

                request.get("/product/selectOne/"+this.sn+"/"+this.value).then(res =>{

                    this.tableData=[];
                    var obj2=JSON.parse(res.data.defined)
                    obj2.name=res.data.name
                    obj2.sn=this.sn
                    this.tableData.push(obj2)




                }).catch((res)=>{
                })

            },
            NameFormat1(row){

                if (row.G==null||row.G==""){
                    this.gcheck=false
                }else{
                    return row.G;
                }
            },
            NameFormat2(row){

                if (row.H==null||row.H==""){
                    this.hcheck=false
                }else{
                    return row.H;
                }
            },
            NameFormat3(row){

                if (row.I==null||row.I==""){
                    this.icheck=false
                }else{
                    return row.I;
                }
            },
            NameFormat4(row){

                if (row.D1==null||row.D1==""){
                    this.d1=false
                }else{
                    return row.D1;
                }
            },
            power(){

                this.form.a=this.proxys.$replace(this.tableData[0].A)
                this.form.b=this.proxys.$replace(this.tableData[0].B)
                this.form.c=this.proxys.$replace(this.tableData[0].C)
                this.form.d=this.proxys.$replace(this.tableData[0].D)
                this.form.e=this.proxys.$replace(this.tableData[0].E)
                this.form.f=this.proxys.$replace(this.tableData[0].F)
                this.form.g=this.proxys.$replace(this.tableData[0].G)
                this.form.h=this.proxys.$replace(this.tableData[0].H)
                this.form.i=this.proxys.$replace(this.tableData[0].I)
                this.form.b1=this.proxys.$replace(this.tableData[0].B1)
                this.form.d1=this.proxys.$replace(this.tableData[0].D1)
                this.form.h1=this.proxys.$replace(this.tableData[0].H1)
                if (this.name.startsWith("H")){
                    this.a=true
                    this.b=true
                    this.c=true

                }else if(this.name.startsWith("UF")||(this.name.startsWith("EE")&&!this.name.startsWith("EED"))||
                    this.name.startsWith("UYF")||this.name.startsWith("EC")||this.name.startsWith("ET")||
                    this.name.startsWith("FT")){
                    this.a=true
                    this.b=true
                    this.c=true
                    this.d=true
                    this.e=true
                    this.f=true

                }else if(this.name.startsWith("EI")||this.name.startsWith("EED")||this.name.startsWith("UI")||
                    this.name.startsWith("EP")) {
                    this.a=true
                    this.b=true
                    this.c=true
                    this.d=true
                    this.e=true
                    this.f=true
                    this.g=true
                }else if(this.name.startsWith("EFD")||(this.name.startsWith("EPC")&&!this.name.startsWith("EP"))) {
                    this.a=true
                    this.b=true
                    this.c=true
                    this.d=true
                    this.e=true
                    this.f=true
                    this.b1=true
                    this.d1=true
                    this.h=true

                }else if(this.name.startsWith("PQ")) {
                    this.a=true
                    this.b=true
                    this.c=true
                    this.d=true
                    this.e=true
                    this.f=true
                    this.g=true
                    this.h=true
                }else if(this.name.startsWith("RM")) {
                    this.a=true
                    this.b=true
                    this.c=true
                    this.d=true
                    this.e=true
                    this.f=true
                    this.g=true
                    this.h=true
                    this.i=true
                    this.h1=true
                }else if(this.name.startsWith("PM")) {
                    this.a=true
                    this.b=true
                    this.c=true
                    this.d=true
                    this.e=true
                    this.f=true
                    this.g=true
                    this.h=true
                    this.i=true
                }else{
                    this.$message({
                        type: "error",
                        message: "不支持计算功率"
                    })
                }

            },
            TPW(){
                this.form.type=1
                let that=this;
                this.$refs['form'].validate((valid) => {
                    if (valid){
                        request.post("/product",this.form).then(res => {
                            if (res.status==0){
                                that.gonglv=[]
                               that.isgonglv = true
                                res.data.name=that.name
                                res.data.sn=that.sn
                                that.gonglv.push(res.data)

                            }else {
                                this.$message({
                                    type: 'warning',
                                    message: res.data
                                });
                            }

                        })
                    }else{
                    }

                })
            }
        },
        beforeMount(){
            const { proxy } = getCurrentInstance()
            this.proxys=proxy




            if (this._isMobile()) {
                this.isPC=false;

            } else {

                this.isPC=true;
            }

            this.sn=this.$route.query.sn
            var obj=""
            request.get("/product/selectOne/"+this.sn+"/2300").then(res =>{
                this.describe= res.data.content
                this.name=res.data.name;
                this.form.name=res.data.name;


                for (let i = 0; i <res.data.image.split(",").length ; i++) {
                    this.lists.push(res.data.image.split(",")[i])
                }

                this.lists.push(res.data.model)
                var obj2=JSON.parse(res.data.defined)
                obj2.name=res.data.name
                obj2.sn=this.sn
                this.tableData.push(obj2)



                if (this.name.startsWith("EE")&&!this.name.startsWith("EEL")&&!this.name.startsWith("EED")){
                    this.canDraw=true
                }else if(this.name.startsWith("UF")&&!this.name.startsWith("UFR")){
                    this.canDraw=true
                }else if(this.name.startsWith("EC")&&!this.name.startsWith("ECO")) {
                    this.canDraw=true
                }else if(this.name.startsWith("H")){
                    this.canDraw=true
                }else if(this.name.startsWith("PQ")){
                    this.canDraw=true

                }else if(this.name.startsWith("EQ")){
                    this.canDraw=true
                }else if(this.name.startsWith("UY")&&!this.name.startsWith("UYF")){
                    this.canDraw=true
                }else{

                }

            }).catch((res)=>{
            })
            request.get("/solution").then(res =>{

                for (let i = 0; i <res.data.length; i++) {
                    let option={value:res.data[i].permeability,
                                label:res.data[i].uniqueId}

                    this.options.push(option)
                }

            }).catch((res)=>{
            })

        },

        watch:{
            form:{//深度监听，可监听到对象、数组的变化
                handler(val){
                    if(val.ee!=2){
                        this.gongcha=false
                    }else{
                        this.gongcha=true
                    }

                    if(val.gg==0){
                        this.qi=false
                    }else{
                        this.qi=true
                    }

                },
                deep:true //true 深度监听
            }


        }


    }
</script>

<style lang="less" scoped>

    .hidden{
        overflow: hidden !important;
    }
    .carouseldiv{
        border:1px solid rgba(64,158,255,.1);
        padding: 5px
    }
    .jianjie{
        padding: 30px 0;
        margin-top: 30px;
        border-top:1px solid rgba(0,0,0,.1);
        border-bottom:1px solid rgba(0,0,0,.1);
        color: #707070;
        font-size: 0.9em;
    }
    .menuBtn{
        li{
            border-bottom: 3px solid white;
            float: left;
            .el-button{
                border: none;
                border-radius: 0;
            }

        }
        li:hover{
            box-sizing: border-box;
            border-bottom: 3px solid #1C86EE;

        }
    }
    .colorChange{
        background-color: #1C86EE;
        color: white;
    }
    @media screen and (max-width: 400px) {
        .briefIntroduction{
            padding-left: 0!important;
        }
    }
    .briefIntroduction{
        padding-left: 80px;
    }
    .form{
        padding-top: 20px;
    }
    .el-form-item__label{
        width: 120px !important;
    }
    .el-table .cell{
        line-height: 35px;
    }
</style>